import React from "react";
import "./Services.css";
import serviceImg from "../assets/gallery/IMG_4002.jpg";
import { FaPaintRoller, FaPlug, FaTools } from "react-icons/fa";

const Services = () => {
  return (
    <section className="services" id="services">
      {/* Centered Main Heading */}
      <h2 className="services-title">Our Services</h2>

      <div className="services-container">
        {/* Left Side Image */}
        <div className="services-image">
          <img src={serviceImg} alt="Our Services" />
        </div>

        {/* Right Side Content */}
        <div className="services-content">
          <p className="intro-text">
            We offer a complete range of <strong>paints, electricals, and hardware solutions</strong>
            designed to meet both residential and commercial needs with quality and reliability.
          </p>
          <br></br>
          <ul className="services-list">
            <li>
              <FaPaintRoller className="icon" />
              <div>
                <h4>Paints</h4>
                <p>
                  Explore a wide selection of <strong>interior and exterior paints</strong> in
                  various finishes. Our collection provides vibrant colors, durability, and
                  long-lasting protection for every surface.
                </p>
              </div>
            </li>

            <li>
              <FaPlug className="icon" />
              <div>
                <h4>Electricals</h4>
                <p>
                  We supply <strong>high-quality electrical materials</strong> including wires,
                  switches, lighting fixtures, and circuit accessories—ensuring safety,
                  performance, and efficiency.
                </p>
              </div>
            </li>

            <li>
              <FaTools className="icon" />
              <div>
                <h4>Hardwares</h4>
                <p>
                  Discover a complete range of <strong>hardware tools, fittings, and construction materials</strong>
                  built for strength and durability—perfect for home improvement and industrial use.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Services;
